export default class ReasonsCancellationJustify {
  id: string;

  parent: string;

  name: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.parent = obj.parent || '';
    this.name = obj.name || '';
  }

  public static of(obj: any): ReasonsCancellationJustify {
    return new ReasonsCancellationJustify(obj);
  }

  public static ofList(obj: any = []): ReasonsCancellationJustify[] {
    return obj.map(this.of);
  }
}
